import { TeamContext } from "@redotech/redo-merchant-app-common/team";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Text } from "@redotech/redo-web/text";
import { memo, useContext } from "react";

export const ClosedFulfillmentGroupModal = memo(
  function ClosedFulfillmentGroupModal({
    onContinue,
    onBack,
    open,
  }: {
    onContinue: () => void;
    onBack: () => void;
    open: boolean;
  }) {
    const team = useContext(TeamContext);
    if (!team?.settings.outboundLabels.warnOnClosedInScan) {
      return null;
    }

    return (
      <RedoModal
        isOpen={open}
        onModalCloseRequested={onContinue}
        primaryButton={{ text: "Continue", onClick: onContinue }}
        secondaryButton={{ text: "Back", onClick: onBack }}
        title="Shipment already fulfilled"
      >
        <Text>
          This label has already been printed. Are you sure you want to proceed?
        </Text>
      </RedoModal>
    );
  },
);
